export default "__VITE_ASSET__DJmlIxMd__"